import type { User } from '@/shared/api'
import { cn } from '@/shared/lib/cn'
import s from './UserAvatar.module.css'

type UserAvatarProps = {
  user: Pick<User, 'initials'>
  size: 28 | 42
  className?: string
}

/**
 * Аватар пользователя — фиксированный `var(--st-in)`, 1:1 с макетом (prototype/Prototype.dc.html,
 * строки 214, 221). В отличие от `Company`/`PlatformService`, `User` не несёт `colorKey`
 * (`openapi/components/schemas/session.yaml`) — палитра по пользователям контрактом не
 * предусмотрена. Это не забытые данные, а стилевой выбор фронта, который сервер и не обещал.
 */
export function UserAvatar({ user, size, className }: UserAvatarProps) {
  return <span className={cn(s.root, size === 42 ? s.lg : s.sm, className)}>{user.initials}</span>
}
